// Editable site configuration for Lorena Cotano
export const PHONE_DISPLAY = "+34 684 751 197";
export const WHATSAPP_NUMBER = "34684751197"; // wa.me format, no spaces or +
export const WHATSAPP_MESSAGE = encodeURIComponent(
  "Hola Lorena, me gustaría reservar una sesión de acompañamiento."
);
export const whatsappLink = () =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

// MATRUM mobile app link — subdomain (IONOS)
export const MATRUM_APP_URL = "https://matrum.lorenacotano.com";

export const INSTAGRAM = [
  {
    handle: "@lorenacotano",
    url: "https://instagram.com/lorenacotano",
    label: "Lorena Cotano",
    desc: "Mi cuenta personal",
  },
  {
    handle: "@matrum_embarazo",
    url: "https://instagram.com/matrum_embarazo",
    label: "MATRUM Embarazo",
    desc: "Para tu gestación",
  },
  {
    handle: "@matrum_puerperio",
    url: "https://instagram.com/matrum_puerperio",
    label: "MATRUM Puerperio",
    desc: "Para tu postparto",
  },
  {
    handle: "@matrum_menopausia",
    url: "https://instagram.com/matrum_menopausia",
    label: "MATRUM Menopausia",
    desc: "Para tu madurez",
  },
];
